export const TeletriagePaperStyles = ({ isMobile, expanded }: { isMobile: boolean; expanded: boolean }) => {
	const styles = {
		position: 'fixed',
		right: '1.25rem',
		maxWidth: '374px',
		borderRadius: '1.5rem',
		cursor: 'pointer',
		overflow: 'hidden', // Hide content that overflows during animation
		userSelect: 'none',
		transition: 'width 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
		bottom: '2.5rem',
		padding: '1rem 1.5rem',
		width: '374px',
		zIndex: 1,
	};

	if (isMobile) {
		return {
			...styles,
			bottom: '1.875rem',
			padding: '1rem 0.75rem',
			width: expanded ? '80%' : '64px',
		};
	}

	return styles;
};

const mobileExpandedStyles = {
	opacity: 1,
	height: 'auto',
	width: 'auto',
	transform: 'translateY(0)',
	transition: `all 0.3s ease-in-out 0.4s`,
};

const mobileNonExpandedStyles = {
	opacity: 0,
	height: 0,
	width: 0,
	transform: 'translateY(-10px)',
	transition: '',
};

export const mobileStyles = (expanded: boolean) => (expanded ? mobileExpandedStyles : mobileNonExpandedStyles);
